import { useRef, useState } from "react";
import ReactPlayer from "react-player";
import { BsPlayFill, BsPauseFill } from "react-icons/bs";
import { getEnvVariables } from "../../helpers";

export const VideoPlayer = ({
  videoSrc,
  markVideoAsSeen,
  containerClass,
  maxHeight,
  height,
}) => {
  const playerRef = useRef(null);
  const [lastTime, setLastTime] = useState(0);
  const [playing, setPlaying] = useState(true);
  const [showControls, setShowControls] = useState(false);
  const { REACT_APP_NODE_ENV } = getEnvVariables();
  const isDev = REACT_APP_NODE_ENV !== "production";

  // Guarda el último tiempo reproducido
  const handleProgress = (state) => {
    // Si el usuario retrocede, actualiza lastTime
    if (state.playedSeconds < lastTime && !isDev) {
      setLastTime(state.playedSeconds);
    }
    // state.playedSeconds es el tiempo actual
    else if (state.playedSeconds - lastTime > 2 && !isDev) {
      // Si se adelantó más de 2 segundos, lo regresa
      playerRef.current.seekTo(lastTime, "seconds");
    } else {
      setLastTime(state.playedSeconds);
    }
  };

  // Mostrar controles al mover el mouse
  const handleMouseMove = () => {
    setShowControls(true);
    if (playing) {
      clearTimeout(window.hideControlsTimeout);
      window.hideControlsTimeout = setTimeout(
        () => setShowControls(false),
        1500
      );
    }
  };

  return (
    <div className={containerClass}>
      <div
        style={{
          maxHeight,
          aspectRatio: "9/16",
          cursor: "pointer",
          position: "relative",
        }}
        onMouseMove={handleMouseMove}
      >
        <ReactPlayer
          ref={playerRef}
          url={videoSrc}
          playing={playing}
          controls={isDev}
          onProgress={handleProgress}
          config={{
            file: {
              attributes: {
                controlsList: "nodownload", // Desactiva descarga
                disablePictureInPicture: true, // Desactiva Picture-in-Picture
              },
            },
          }}
          width="100%"
          height={height}
          onPlay={() => setPlaying(true)}
          onPause={() => setPlaying(false)}
          onEnded={markVideoAsSeen}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: isDev ? "80px" : 0,
            background: "transparent",
          }}
          onClick={(e) => {
            e.stopPropagation();
            setPlaying((p) => !p);
          }}
        />
        <button
          onClick={(e) => {
            e.stopPropagation();
            setPlaying((p) => !p);
          }}
          className="video-play-btn position-absolute top-50 start-50 translate-middle bg-white border-0 rounded-circle shadow"
          style={{
            opacity: !playing || showControls ? 0.9 : 0,
            pointerEvents: !playing || showControls ? "auto" : "none",
            transition: "opacity 0.2s",
          }}
          tabIndex={-1}
        >
          {playing ? <BsPauseFill size={36} /> : <BsPlayFill size={36} />}
        </button>
      </div>
    </div>
  );
};
